import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "@/components/loader/Loader.vue";
import AddHocActivityDialog from "./addHocActivityDialog/AddHocActivityDialog.vue";

export default {
  name: "AdHocActivitiesManager",
  components: {
    ValidationObserver,
    ValidationProvider,
    AddHocActivityDialog,
    ConfirmDlg,
    Loader
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: this.$t('GeneralTranslations.Name'),
          value: "name",
          sortable: false,
          width:'*'
        },
        {
          text: "",
          value: "id",
          sortable: false,
          width:200
        }
      ]
    }
  },
  async created() {
    await this.$store.dispatch("getAdHocActivitiesTypes");
  },
  computed: {
    currentFacility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    adHocActivitiesTypes() {
      return this.$store.state.adHocActivitiesModule.adHocActivitiesTypes
    }
  },
  methods: {
    openUpsertAdHocActivityTypeDialog(data) {
      this.$refs.addAdHocActivityTypeDialog.open(data);
    },
    async deleteAdHocActivityType(row) {
      const records = await this.$store.dispatch("isAdHocTypeInUse", row.id) 

      const message = records?.length > 0? 
      this.$t('Settings.ActivitiesManager.AdHocActivityTypeWithDependencyQuestion'):
      this.$t('Settings.ActivitiesManager.DeleteAdHocActivityType').replace('[name]', row.name)

      this.$refs.confirmationModal.open(null, message, false)
      .then(response => {
        if (response && response.agree) {
          this.$store.dispatch("deleteAdHocActivityType", row.id);
        }
      });
    }
  },

}